module.exports = __webpack_public_path__ + "static/media/testimonial-1.3ac8eb05.mp4";